module.exports = __webpack_public_path__ + "img/EACalculateItem1.1256748c.svg";